
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import ecc from 'eosjs-ecc'
import Divider from "../node_modules/vux/src/components/divider/index";
import { eosApi } from './api'
import Clipboard from 'clipboard'

export default {
components: {
Divider,
Group,
Cell
},
data () {
return {
nameError: '必须输入账户名',
keyError: '必须输入公钥KEY',
key: '',
name: '',
account: null,
}
},
methods: {
checkPublicKey (value) {
if (ecc.isValidPublic(value)) {
this.keyError = null
} else {
this.keyError = '公钥不合法，请检查'
}
},
checkName (value) {
this.account = null;
if (value.length == 0) {
this.nameError = '必须输入账户名';
} else if (value.length !== 12){
this.nameError = '账户名必须是 12 位';
} else if (/[a-z1-5]{12}/.test(value)){
eosApi.getAccount(value).then(function (account) {
this.account = account;
this.nameError = '账号已存在';
}.bind(this), function (err) {
this.nameError = null;
}.bind(this))
} else {
this.nameError = '账户名格式错误';
}
},
copy () {
this.$copyText(this.name+' '+this.key).then(function (e) {
alert('复制成功')
}, function (e) {
alert('复制失败')
})
}
},
}



// WEBPACK FOOTER //
// ./src/home.vue